"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idle_1 = require("./idle");
exports.Idle = idle_1.Idle;
var not_idle_1 = require("./not-idle");
exports.NotIdle = not_idle_1.NotIdle;
//# sourceMappingURL=C:/Documents and Settings/amayo007/Documents/Performance Analyzer/V5/DependentGit/idlejs/src/index.js.map